import { useEffect } from 'react';

import {
	AiStates,
	ErrorStates,
	useBulkCreateContext,
} from '../providers/BulkCreateContextProvider';

import { useAIAgentStreamingData } from './useAIAgentStreamingData';

export const useAiBulkFetchIssuesList = () => {
	const [, { setAiBulkIssuesList, setAiState, setError }] = useBulkCreateContext();
	const { content, currentAiState } = useAIAgentStreamingData();
	useEffect(() => {
		if (content && content.length > 0) {
			void setAiBulkIssuesList(content);
		}
		void setAiState(currentAiState);
		if (currentAiState === AiStates.ERROR) {
			void setError(ErrorStates.ISSUE_GENERATION);
		}
	}, [content, currentAiState, setAiBulkIssuesList, setAiState, setError]);
};
